import React, { useState } from "react";
import ChatboxHeader from "./chat/Header";
import ChatboxBody from "./chat/Body";
import ChatboxFooter from "./chat/Footer";
import useAppState from "context/useAppState";

function ChatBox() {

  const [activeState, setActiveState] = useState<any>("feteBuddy");
  
  const [featureToDisplay, setFeatureToDisplay] = useState<any>({
    feteBuddy: [
      "newChat",
      "middleChat",
      "chatBox"
    ],
    reviewSpace: [
      "middleChat",
    ]
  });

  const activeStateHandler = (value:"feteBuddy" | "reviewSpace") => {
    setActiveState(value)
  }

  const {
		showInsight,
	} = useAppState("eventData");

  return (
    <>
      <div className={`${showInsight ? 'insights' : ''} ${activeState === "feteBuddy" ? "fete-buddy" : "review-space"}`}>
          {/* Header */}
          <ChatboxHeader activeState={activeState} setActiveState={activeStateHandler} featureToDisplay={featureToDisplay} />

          {/* body */}
          <ChatboxBody />

          {/* Footer */}
          <ChatboxFooter />
      </div>

      {/* <FeteAddRemainder/> */}
    </>
  );
}

export default React.memo(ChatBox);
